import _ from 'lodash';
import {
  FETCH_BLACKOUT_DEFINITION,
  RESET_BLACKOUT_DEFINITION,
} from './BlackoutDefinitionFetcherActions';

const INITIAL_STATE = {
  definition: null,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_BLACKOUT_DEFINITION: {
      const definition = _.get(action, 'payload.data');
      const definitionLowercaseKeys = _.transform(definition, (result, val, key) =>
        _.set(result, key.toLowerCase(), val),
      );
      return { definition: definitionLowercaseKeys };
    }
    case RESET_BLACKOUT_DEFINITION: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
